<template>
  <router-link v-if="routerName && query" :to="{name: routerName, query: query}" class="btn-back" :class="[variant, size]"
               @click.native="clickHandler"
               @input.native="sendInputEvent($event)"
               @focus.native="sendFocusEvent($event)"
               @blur.native="sendBlurEvent($event)"
               @mousedown.native="sendMousedownEvent($event)"
               @mouseover.native="sendMouseoverEvent($event)"
               @mouseout.native="sendMouseoutEvent($event)"
               @keydown.native="sendKeydownEvent($event)"
               @keyup.native="sendKeyupEvent($event)">
    <slot></slot>
  </router-link>
  <router-link v-else-if="routerName" :to="{name: routerName}" class="btn-back" :class="[variant, size]"
               @click.native="clickHandler"
               @input.native="sendInputEvent($event)"
               @focus.native="sendFocusEvent($event)"
               @blur.native="sendBlurEvent($event)"
               @mousedown.native="sendMousedownEvent($event)"
               @mouseover.native="sendMouseoverEvent($event)"
               @mouseout.native="sendMouseoutEvent($event)"
               @keydown.native="sendKeydownEvent($event)"
               @keyup.native="sendKeyupEvent($event)">
    <slot></slot>
  </router-link>
  <a v-else-if="href" :href="href" class="btn-back" :class="[variant, size]"
     @click="clickHandler"
     @input="sendInputEvent($event)"
     @focus="sendFocusEvent($event)"
     @blur="sendBlurEvent($event)"
     @mousedown="sendMousedownEvent($event)"
     @mouseover="sendMouseoverEvent($event)"
     @mouseout="sendMouseoutEvent($event)"
     @keydown="sendKeydownEvent($event)"
     @keyup="sendKeyupEvent($event)">
    <slot></slot>
  </a>
  <button v-else class="text btn-back" :class="[variant, size]" @click="clickHandler">
    <slot></slot>
  </button>
</template>

<script>
import FormEvent from '../../components/mixin/FormEvent'
export default {
  mixins: [FormEvent],
  name: 'btn-back',
  props: ['variant', 'size', 'routerName', 'href', 'query', 'trackingName'],
  methods: {
    clickHandler: function (e) {
      this.sendClickEvent(e)
      this.$emit('click', e)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/stylesheets/styles";
  .btn-back {
    display: inline-block;
    width: 380px;
    max-width: 100%;
    text-align: center;
    padding: 17px 0px;
    border-radius: 27px;
    font-size: 14px;
    line-height: 14px;
    background-position: 18px center;
    background-repeat: no-repeat;
    background-size: 8px auto;
    @include mq-up(md) {
      border-radius: 30px;
      font-size: 20px;
      line-height: 24px;
    }
    &.-back {
      background-image: url('../../assets/images/icons/arrow-left-orange.svg');
      background-color: $white;
      color: $black;
      border: 1px solid $secondary;
      &:hover {
        background-image: url('../../assets/images/icons/arrow-left-orange.svg');
        border: 1px solid $primary;
      }
    }
    &.-md {
      background-image: url('../../assets/images/icons/arrow-left-orange.svg');
      background-color: $white;
      color: $black;
      border: 1px solid $secondary;
      &:hover {
        background-image: url('../../assets/images/icons/arrow-left-orange.svg');
      }
    }
    &.-sm {
      width: 240px;
      font-size: 14px;
      padding: 13px 0px;
      @include mq-up(md) {
        width: 160px;
        font-size: 16px;
        line-height: 16px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/button/BtnBack.vue